import { Accordion } from "@szhsin/react-accordion";
import { convertSearchParamsToObject } from "helpers";
import { useTranslation } from "react-i18next";
import { createSearchParams, useSearchParams } from "react-router-dom";
import { SelectableItem, SelectableList } from "ui";

import { SIZES_FILTER_SEARCH_PARAMETER } from "../../../../constants";
import { FilterAccordion } from "../FilterAccordion";
import { SizeFilterProps } from "./SizeFilter.types";

const SizeFilter = ({ sizeAttributeValues }: SizeFilterProps) => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  const sizeOptions = sizeAttributeValues.map((sizeAttValue) => ({
    label: sizeAttValue.value,
    value: sizeAttValue.id as string
  }));

  const sizesSearchParameterValue = searchParams.getAll(
    SIZES_FILTER_SEARCH_PARAMETER
  );

  const sizesListValue = sizeOptions.filter((option) =>
    sizesSearchParameterValue.includes(option.value)
  );

  const onSelectableSizesListChange = (
    selectableSizesOptions: SelectableItem[]
  ) => {
    const existingParams = convertSearchParamsToObject(searchParams);
    const newSizesParameter = selectableSizesOptions.map(
      (option) => option.value
    );

    setSearchParams(
      createSearchParams({
        ...existingParams,
        [SIZES_FILTER_SEARCH_PARAMETER]: newSizesParameter
      })
    );
  };

  const clearSizesFilter = () => {
    searchParams.delete(SIZES_FILTER_SEARCH_PARAMETER);
    setSearchParams(searchParams);
  };

  return (
    <Accordion transition transitionTimeout={250}>
      <FilterAccordion
        header={t("Sizes")}
        isClearDisplay={sizesSearchParameterValue.length > 0}
        onClearClick={clearSizesFilter}
      >
        <SelectableList
          values={sizesListValue}
          options={sizeOptions}
          onChange={onSelectableSizesListChange}
        />
      </FilterAccordion>
    </Accordion>
  );
};

export default SizeFilter;
